class MainProduct extends HTMLElement {
  constructor(){ super(); }
  connectedCallback(){
    this.initSlider();
    this.initTabs();
    this.pageMode = this.detectMode();
    if (this.pageMode !== 'bundle') this.initVariants();
    this.initATC();
  }

  detectMode(){
    const isBundle = !!this.querySelector('.bundle[data-bundle="true"]');
    if (isBundle) return 'bundle';
    const hasFlavours = !!this.querySelector('.flavours-grid .flavour-card');
    const hasVariantButtons = !!this.querySelector('.pack-buttons .pack-btn');
    if (hasFlavours && hasVariantButtons) return 'flavour+variants';
    if (hasVariantButtons) return 'variants';
    return 'simple';
  }

  initSlider(){
    const scope = this;
    const thumbsSwiper = new Swiper(scope.querySelector('.swiper-thumbs'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    });
    this.swiper = new Swiper(scope.querySelector('.swiper-product'), {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 0,
      loop: true,
      observer: true,
      observeParents: true,
      navigation: { nextEl: scope.querySelector('.swiper--next'), prevEl: scope.querySelector('.swiper--prev') },
      thumbs: { swiper: thumbsSwiper },
      breakpoints: { 989: { spaceBetween: 0, initialSlide: 0, } }
    });
  }

  initVariants(){
    const packBtns = this.querySelectorAll('.pack-btn');
    if (!packBtns.length) return;
    const variantInput = this.querySelector('#variantIdInput');
    const addBtn = this.querySelector('#addToCartBtn');
    const priceSpan = addBtn ? addBtn.querySelector('span:last-child') : null;

    const getSizeInfo = (btn) => {
      const sizeEl = btn.querySelector('.button__size');
      const sizeText = (sizeEl ? sizeEl.textContent : btn.textContent).trim();
      const m = sizeText.match(/\d+/);
      const qty = m ? parseInt(m[0], 10) : null;
      return { sizeText, qty };
    };

    const notifySticky = (btn) => {
      const { sizeText, qty } = getSizeInfo(btn);
      const detail = {
        variantId: btn.dataset.variantId || '',
        price: btn.dataset.price || (priceSpan ? priceSpan.textContent : null),
        sizeText,
        qty
      };
      document.dispatchEvent(new CustomEvent('monka:pack-change', { detail }));
    };

    const setActive = (btn)=>{
      packBtns.forEach(b=>b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (variantInput) variantInput.value = btn.dataset.variantId || '';
      if (priceSpan && btn.dataset.price) priceSpan.textContent = btn.dataset.price;

      notifySticky(btn); 
    };

    packBtns.forEach(btn=>{
      btn.addEventListener('click', ()=>{
        if (btn.disabled) return;
        setActive(btn);
      });
    });

    const initial = Array.from(packBtns).find(b=>b.classList.contains('is-active')) || packBtns[0];
    if (initial) {
      setActive(initial);
    }
  }

  

  initTabs(){
    const tabs = this.querySelectorAll('.tab-btn');
    const panels = this.querySelectorAll('.tab-panel');
    tabs.forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const target = btn.dataset.tab;
        tabs.forEach(b=>{
          b.classList.toggle('is-active', b===btn);
          b.setAttribute('aria-selected', b===btn ? 'true' : 'false');
        });
        panels.forEach(p=>{
          p.classList.toggle('is-active', p.dataset.panel === target);
        });
      });
    });
  }

  initATC(){
    const btn = this.querySelector('#addToCartBtn');
    if (!btn) return;
    const variantInput = this.querySelector('#variantIdInput');

    const openDrawerNow = () => {
      const d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return; }
      const t = document.querySelector('[data-cart-trigger], [data-drawer-toggle="cart"], button[aria-controls="CartDrawer"], .header__icon--cart');
      if (t) { t.click(); return; }
    };

    const refreshSections = async () => {
      const res = await fetch(`/?sections=cart-drawer,cart-icon-bubble`, { headers: { 'Accept':'application/json' }});
      const json = await res.json();
      const wrap = document.createElement('div');
      if (json['cart-icon-bubble']) {
        const bubbleTarget = document.querySelector('#cart-icon-bubble, .cart-icon-bubble');
        wrap.innerHTML = json['cart-icon-bubble'];
        const bubbleNew = wrap.firstElementChild;
        if (bubbleTarget && bubbleNew) bubbleTarget.replaceWith(bubbleNew);
        wrap.innerHTML = '';
      }
      if (json['cart-drawer']) {
        const oldDrawer = document.querySelector('cart-drawer');
        wrap.innerHTML = json['cart-drawer'];
        const newDrawer = wrap.querySelector('cart-drawer');
        if (oldDrawer && newDrawer) oldDrawer.replaceWith(newDrawer);
        wrap.innerHTML = '';
      }
      requestAnimationFrame(openDrawerNow);
    };

    btn.addEventListener('click', async (e)=>{
      e.preventDefault();
      btn.disabled = true;
      try{
        const id = variantInput && variantInput.value;
        if (!id) return;
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });
        if (!r.ok) throw new Error('add failed');
        await refreshSections();
      }catch(err){
      }finally{
        btn.disabled = false;
      }
    });
  }
}
customElements.define('main-product', MainProduct);
